"use client";

import { Typography } from "@mui/material";
import { FlexRowCenter } from "@/components/flex-box";
import BoxLink from "page-sections/sessions/components/box-link";
import AuthLayout from "page-sections/sessions/layout";

export default function Layout({ children }) {
  return (
    <AuthLayout
      bottomContent={
        <FlexRowCenter gap={1} my={3}>
          <Typography variant="body2">¿No tienes cuenta?</Typography>
          <BoxLink title="Crear cuenta" href="/register" />
        </FlexRowCenter>
      }
    >
      {children}
    </AuthLayout>
  );
}